var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Column',{staticClass:"text-left",class:_vm.sizeClasses},[_c('hr')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }